import { render, staticRenderFns } from "./ApprovePositionDescriptionDialog.vue?vue&type=template&id=4e8fce24&scoped=true&"
import script from "./ApprovePositionDescriptionDialog.vue?vue&type=script&lang=js&"
export * from "./ApprovePositionDescriptionDialog.vue?vue&type=script&lang=js&"
import style0 from "./ApprovePositionDescriptionDialog.vue?vue&type=style&index=0&id=4e8fce24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8fce24",
  null
  
)

export default component.exports